import { pickPassTarget, type MatchState, type EntityId, type SimConfig } from '@fafi/shared';
import type { ViewState } from './viewState';

// D34 receiver highlight: who would a PASS soft-lock right now? Runs the SAME selection the sim
// applies in applyKicks (pickPassTarget), but over the render-side ViewState — presentation only;
// the server stays authoritative. Returns null when the kicker doesn't hold the ball or no cone
// teammate exists.

/** Compute the soft-locked pass target for the kicker at the current aim/charge. */
export function passSoftLock(view: ViewState, kicker: EntityId, aimYaw: number, chargeTicks: number, cfg: SimConfig): EntityId | null {
  const me = view.entities.find((e) => e.id === kicker);
  if (!me?.hasBall) return null;
  const k = cfg.actions.kick;
  const curve = Math.pow(Math.min(chargeTicks, k.CHARGE_CAP) / k.CHARGE_CAP, k.CHARGE_EXP);
  const speed = k.KICK_MIN + (k.MAX.PASS - k.KICK_MIN) * curve;
  // minimal MatchState-shaped shim — pickPassTarget reads id/team/sentOff/pos/vel/calling.
  // D51: `calling` MUST ride along — the sim's CALL bonus bends the pass to a calling teammate, and a
  // shim without it showed the ring on one mate while the ball went to the caller ("random direction").
  const shim = {
    players: view.entities.map((e) => ({ id: e.id, team: e.team, sentOff: e.sentOff, pos: e.pos, vel: e.vel, calling: e.calling })),
  } as unknown as MatchState;
  return pickPassTarget(shim, kicker, { x: view.ball.pos.x, y: view.ball.pos.y }, aimYaw, speed, cfg)?.id ?? null;
}
